import React from "react";
import { ChevronRight, Clock, Edit, Play, Route as RouteIcon, Target, Trash2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { difficultyLabels, formatRunTime, intervalTypeNames } from "../../constants/running";

// Detail view for a running plan, with its interval breakdown.
const RunningPlanDetail = ({
  deleteRunningPlan,
  selectedRunningPlan,
  setEditingRunningPlan,
  setNewRunningPlan,
  setRunningView,
  startRunningSession,
}) => {
  return (
    <div className="plan-detail-view">
      <Button variant="ghost" size="sm" onClick={() => setRunningView("list")}><ChevronRight size={16} className="rotate-180" /> Powrót</Button>
      <h2>{selectedRunningPlan.name}</h2>
      {selectedRunningPlan.description && <p className="plan-desc">{selectedRunningPlan.description}</p>}
      {selectedRunningPlan.goal && <p className="plan-goal-text"><Target size={16} /> Cel: {selectedRunningPlan.goal}</p>}
      <div className="plan-meta-row">
        <span><Clock size={14} /> {selectedRunningPlan.estimated_duration_minutes || "?"} min</span>
        <span><RouteIcon size={14} /> {selectedRunningPlan.estimated_distance_km || "?"} km</span>
        <Badge variant="outline">{difficultyLabels[selectedRunningPlan.difficulty] || selectedRunningPlan.difficulty}</Badge>
      </div>

      <h3 className="intervals-title">Interwały ({selectedRunningPlan.intervals?.length})</h3>
      <div className="intervals-timeline">
        {selectedRunningPlan.intervals?.map((interval, idx) => (
          <div key={idx} className={`interval-item interval-${interval.type}`}>
            <div className="interval-order">{idx + 1}</div>
            <div className="interval-info">
              <span className="interval-type-name">{intervalTypeNames[interval.type] || interval.type}</span>
              <span className="interval-dur">{formatRunTime(interval.duration_seconds)}</span>
            </div>
            {interval.target_pace_min && interval.target_pace_max && (
              <span className="interval-pace">{interval.target_pace_min.toFixed(1)}-{interval.target_pace_max.toFixed(1)} min/km</span>
            )}
            {interval.description && <span className="interval-desc">{interval.description}</span>}
          </div>
        ))}
      </div>

      <div className="plan-detail-actions">
        <Button className="start-plan-btn" onClick={() => startRunningSession(selectedRunningPlan)}><Play size={20} /> Rozpocznij trening</Button>
        {selectedRunningPlan.type !== "predefined" && (
          <>
            <Button variant="outline" onClick={() => {
              setEditingRunningPlan(selectedRunningPlan);
              setNewRunningPlan({
                name: selectedRunningPlan.name, description: selectedRunningPlan.description || "",
                goal: selectedRunningPlan.goal || "", difficulty: selectedRunningPlan.difficulty || "medium",
                intervals: selectedRunningPlan.intervals || [], tags: selectedRunningPlan.tags || [],
                estimated_distance_km: selectedRunningPlan.estimated_distance_km || "",
                estimated_duration_minutes: selectedRunningPlan.estimated_duration_minutes || ""
              });
              setRunningView("plan_editor");
            }}><Edit size={16} /> Edytuj</Button>
            <Button variant="destructive" size="sm" onClick={() => { deleteRunningPlan(selectedRunningPlan.id); setRunningView("list"); }}><Trash2 size={16} /> Usuń</Button>
          </>
        )}
      </div>
    </div>
  );
};

export default RunningPlanDetail;
